import { useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import Tab from 'src/components/navigation/Tab';
import TabRow from 'src/components/navigation/TabRow';
import payStationsMessages from 'src/features/payStations/utils/messages';

const PayStationsLayout = () => {
    const { formatMessage } = useIntl();
    return (
        <MainLayout>
            <TabRow>
                <Tab end to="/pay-stations">
                    {formatMessage(payStationsMessages.devices)}
                </Tab>
                <Tab to="/pay-stations/all-logs">{formatMessage(payStationsMessages.allLogs)}</Tab>
                <Tab end to="/pay-stations/all-heart-beats">
                    {formatMessage(payStationsMessages.allHeartBeats)}
                </Tab>
            </TabRow>
            <Outlet />
        </MainLayout>
    );
};

export default PayStationsLayout;
